module.exports = __webpack_public_path__ + "img/easyremessa.26785780.webp";